<div class="page-title-area title-img-one">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="page-title-text">
                <h2>Practice Areas Details</h2>

                <ul>
                    <li><a [routerLink]="homeUrl">Home</a></li>
                    <li><i class="icofont-simple-right"></i></li>
                    <li>Practice Areas Details</li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div class="practice-details-area pt-100">
    <div class="container">
        <div class="row">
            <div class="col-lg-8">
                <div class="practice-details-item">
                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'ADR Law'">
                        <div class="section-title text-start">
                            <h2>Alternate Dispute Resolution (ADR) and Arbitration</h2>
                        </div>
                        <p> Alternate Dispute Resolution(ADR) refers to any method of resolving disputes without
                            litigation. We provide all kinds of services in Arbitration, ADR regroups, and all processes
                            and techniques of conflict resolution that occur outside of any governmental authority. The most
                            famous ADR methods are the following. Mediation, Arbitration, Conciliation, Negotiation and
                            Transactions.
                        </p>
                        <b>DIFFERENT TYPES OF ARBITRATION: </b>
                        <br /><br />
                        <ul>
                            <li>
                                <b>National Arbitration: </b>for example, American arbitration, French arbitration, or German
                                arbitration which are all governed by different rules enacted by the institutions of each country;
                            </li>
                            <li>
                                <b>International commercial arbitration: </b>usually used to settle disputes that arise from
                                commercial contractual relations between buyers and sellers who are in two different states; 
                            </li>
                            <li>
                                <b>Investor-State arbitration: </b>unilateral referral by the private individual investors to an
                                arbitral tribunal against a host State of their investment.
                            </li>
                        </ul>
                        <p>Other types of arbitration and areas of specialization of this ADR exist, such as construction
                            arbitration, post-M&A arbitration, etc.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Labour Law'">
                        <div class="section-title text-start">
                            <h2>Management and Labour Employment Law</h2>
                        </div>
                        <p> Workers are protected by the Labour Employment Law as per the constitution of Pakistan. We offer experienced
                            attorneys that can help you with the management and the labour employment. 
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Admin Law'">
                        <div class="section-title text-start">
                            <h2>Regulatory and Administrative Law</h2>
                        </div>
                        <p> We regularly practice before administrative agencies and commissions at the
                            federal, provincial, and local levels. We have experience with licensing, 
                            permitting, compliance, enforcement, rulemaking, zoning, land use, and other
                            regulatory issues. 
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Banking Law'">
                        <div class="section-title text-start">
                            <h2>Commercial and Banking</h2>
                        </div>
                        <p> Commercial lending is an important area of practice for us. Although our 
                            expertise covers the spectrum of commercial lending transactions, the bulk of 
                            our work falls into two areas. One representation of banks, insurance companies,
                            and other clients that lend money, and two represents businesses and 
                            individuals that borrow regularly.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Litigation Law'">
                        <div class="section-title text-start">
                            <h2>Litigation Group</h2>
                        </div>
                        <p> We handle virtually all kinds of civil, criminal, and commercial 
                            litigation at the administrative, trial court, and appellate levels 
                            and through the various channels of alternative dispute resolution. 
                            We practice regularly in all provincial trial Courts, High Courts, and 
                            the Supreme Court of Pakistan. We all so manage litigation in 
                            international jurisdiction in collaboration with law firms in those 
                            jurisdictions.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Corporate Law'">
                        <div class="section-title text-start">
                            <h2>Corporate and Securities</h2>
                        </div>
                        <p> Corporate law is the medium on which predominately all of our firm’s practice 
                            is based. We advise closely-held businesses as well as publicly traded 
                            corporations in a wide variety of areas. We serve the needs of growing 
                            businesses and the venture capital and investment banking firms that provide 
                            them with capital.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Intellectual Law'">
                        <div class="section-title text-start">
                            <h2>Intellectual Property</h2>
                        </div>
                        <p> We have experts who can deal with your needs, as they are fully aware of 
                            the technical as well as legal complications in the field of intellectual 
                            property. As the use and importance of technology in businesses are 
                            growing, the protection of the technology is becoming essential. We help 
                            in drafting agreements and contractual restrictions on the use of 
                            confidential information by employees, outside consultants, or other third 
                            parties. We also help in licensing the use of trade secrets, patents, 
                            trademarks, and copyrights. We also assist in the registration of 
                            copyrights and trademarks.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Constitutional Law'">
                        <div class="section-title text-start">
                            <h2>Constitutional and Public Interest</h2>
                        </div>
                        <p>Every individual and business have rights under the constitution and they 
                            have an inherent right to enjoy the constitutional securities and rights. 
                            However, at times these are violated and we make available our expertise 
                            and services in ensuring that constitutional rights are protected and 
                            enforced. In addition to the matters relating to the Constitution of 
                            Pakistan, we also advise on matters relating to the constitution of public 
                            and private institutions.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Estate Law'">
                        <div class="section-title text-start">
                            <h2>Estate Planning</h2>
                        </div>
                        <p>Estate planning is a process involving the counsel of professional 
                            advisors who are familiar with your goals and concerns, your assets 
                            and how they are owned, and your family structure. It can involve the 
                            services of a variety of professionals, including your lawyer, 
                            accountant, financial planner, life insurance advisor, banker and 
                            broker. <br />
                            Estate planning covers the transfer of property at death as well as a 
                            variety of other personal matters and may or may not involve tax 
                            planning. The core document most often associated with this process is 
                            your will.
                        </p>
                    </div>


                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Advisory Law'">
                        <div class="section-title text-start">
                            <h2>Advisory and Transaction</h2>
                        </div>
                        <p>Over time, we have realized that to provide a legal structure to a 
                            transaction, the same has to be supported by the financial aspect of the 
                            transaction to make it a one window viable solution. For this purpose, 
                            the firm has recently hired services of financial consultants to provide 
                            the clients with a legally and financially tenable structure. Our Advisory 
                            and Transaction group combines the expertise of both legal experts and 
                            financial experts to structure a tailor-made transaction keeping in view 
                            the requirements of the Clients. 
                        </p>
                    </div>

                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Family Law'">
                        <div class="section-title text-start">
                            <h2>Family and Custody Law</h2>
                        </div>
                        <p> Child welfare is the key factor taken into consideration by the court while granting custodial rights to any parent. Thus, aspects such as financial stability of parent, reported misconduct, character, and capacity of parent are given importance. </p>

                        <p> The courts grant physical rights to one parent, however increased number of cases have seen shared legal responsibility and guardianship of any child(ren). Thus custodial laws in Pakistan can also be classified as physical and legal. </p>
                            
                        <p> According to the judicial system established in Pakistan, the legal right over minors implies that the parent is solely responsible for the welfare of the juvenile in question. </p>
                            
                        <p> While dealing with such issues, the court considers the preference of the minor in question, if he/she is old enough to form an intelligent preference. </p>
                            
                        <p> Traditionally in Pakistan, mothers were given ownership of minor, but the trend has been showing signs of change. More and more women are opting for career-driven lives, which may not enable them to bring up their children as a single parent. </p>
                    </div>

                    <div class="practice-details-content" *ngIf = "nameOfLaw === 'Criminal Law'">
                        <div class="section-title text-start">
                            <h2>Criminal Law</h2>
                        </div>
                        <p> The fundamentals of criminal law are based on the principle of justice, equity and good conscience. They provide adequate guidelines for the formulation of a rational penal policy. In order to be influential the criminal law must have four important elements, that is, politicality, specificity, uniformity and penal sanction. The functioning of the criminal justice system is wide enough to achieve its goals and objectives. Its ultimate goal is undoubtedly to make the society safer for its citizens. Most widely accepted aims of the criminal law include: </p>
                        
                        <ol>
                            <li>The enforcement of criminal law should reflect the society’s disapprobation for criminal activity through apprehending, convicting and punishing the offenders.</li>
                            
                            <li>Deterring criminals from indulging in criminal activities and at the same advising the other people as to how to avoid falling a victim to a crime.</li>
                            
                            <li>Criminal law should be beneficially used to rehabilitate the offenders and incapacitating those who might otherwise prove to be a potential danger to the society.</li>
                            
                            <li>Ensuring safety and security of people through maintenance of law and order.</li>
                            
                            <li>Helping the victims to get adequate compensation from the offender wherever possible.</li>
                            
                            <li>Efficient and fair application of law ensuring proper treatment of suspects, defendants, those who are held in custody and witnesses. Also ensuring that the innocents are acquitted without harassment and guilty is duly punished.</li>
                            
                            <li>Ensuring that criminal justice system is accountable to the society.</li>
                        </ol>
                        
                    </div>
                </div>

                
            </div>

            <div class="col-lg-4">
                <div class="practice-details-item">
                    <div class="blog-details-category">
                        <ul>
                            <li><a (click) = "nameOfLaw = 'ADR Law'" >ADR and Arbitration <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Labour Law'" >Management and Labour Employment Law <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Admin Law'" >Regulatory and Administrative Law <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Banking Law'" >Commercial and Banking <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Litigation Law'" >Litigation Group <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Corporate Law'" >Corporate and Securities <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Intellectual Law'" >Intellectual Property <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Constitutional Law'" >Constitutional and Public Interest <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Estate Law'" >Estate Planning <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Advisory Law'" >Advisory and Transaction <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Family Law'" >Family and Custody Law <i class="icofont-arrow-right"></i></a></li>
                            <li><a (click) = "nameOfLaw = 'Criminal Law'" >Criminal Law <i class="icofont-arrow-right"></i></a></li>
                        </ul>
                    </div>

                    <div class="practice-details-contact">
                        <h3>Contact Info</h3>

                        <ul>
                            <li><i class="flaticon-call"></i> <a href="tel:+923100022272">Call : 009 231 000 222 72</a></li>
                            <li><i class="flaticon-email"></i> <a href="mailto:admin@walayetlaw.com">admin@walayetlaw.com</a></li>
                            <li><i class="flaticon-pin"></i> Office No 03, LG Sami Plaza, Opposite Lahore High Court, Rawalpindi Bench, Rawalpindi</li>
                        </ul>
                    </div>

                    <div class="practice-details-brochures">
                        <h3>Brochures</h3>
                        <p>Download Our Company Profile</p>
                        <a class="cmn-btn" href="#"><i class="flaticon-download"></i>Download</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="help-shape">
        <img src="assets/img/home-one/6.png" alt="Shape">
    </div>
</div>